import ComparisonGraphList from './ComparisonGraphList'

export default ComparisonGraphList;